module.exports = __webpack_public_path__ + "static/media/22.acf3df30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/22.svg
// module id = 135
// module chunks = 0